import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import clsx from "clsx";
import palette from "../../theme/palette";

import Paper from "@material-ui/core/Paper";

import { withRouter } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto"
  },
  mainheading: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(2),
    alignItems: "center",
    display: "flex"
  },
  heading: {
    marginBottom: theme.spacing(3)
  },

  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0",
      paddingRight: "0",
      paddingTop: theme.spacing(0)
    }
  },
  iconRight: {
    marginRight: "1.2rem"
  },
  paper: {
    width: "100%",
    height: "100%",
    padding: "2.5rem"
  },
  greenPaper: {
    backgroundColor: palette.secondary.light,
    boxShadow: "none"
  },
  contactFormPaper: {
    maxWidth: "71.5rem"
  },
  bigAvatar: {
    marginRight: theme.spacing(3),
    width: 92,
    height: 92
  },
  flexDiv: {
    display: "flex",
    alignItems: "center"
  },
  flexCol: {
    display: "flex",
    flexDirection: "column"
  },
  button: {
    alignSelf: "flex-end"
  }
}));

function HelpPage(props) {
  const classes = useStyles();

  return (
    <main className={classes.content}>
      <div className={classes.appBarSpacer} />

      <Container maxWidth="xl" className={classes.container}>
        <Grid container spacing={0}>
          <Grid container spacing={3} className={classes.centerVert}>
            <Grid item xs={12} align="left">
              <Typography
                variant="h3"
                component="h3"
                align="left"
                className={classes.mainheading}
              >
                <InfoIcon className={classes.iconRight} /> Hjelp
              </Typography>
            </Grid>
            <Grid item xs={12} align="left">
              <Paper className={clsx(classes.greenPaper, classes.paper)}>
                <Typography
                  color="textPrimary"
                  className={classes.depositContext}
                >
                  På denne siden vil du etterhvert få hjelp til bruk av
                  partnerportalen. Men foreløpig kan du hjelpe oss med å avdekke
                  feil og mangler. Du kan melde inn feil og mangler på siden for
                  tilbakemelding.
                </Typography>
              </Paper>
            </Grid>

            <Grid item xs={12} align="left">
              <Paper className={clsx(classes.paper)}>
                <Typography
                  variant="h3"
                  component="h3"
                  align="left"
                  className={clsx(classes.flexDiv, classes.heading)}
                >
                  Ofte stilte spørsmål
                </Typography>

                <Typography
                  color="textPrimary"
                  className={classes.depositContext}
                >
                  Underveis i testingen vil vi lage et sett med ofte stilte
                  spørsmål og svar. Her er det tomt nå, men sjekk tilbake
                  senere.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </main>
  );
}

export default withRouter(HelpPage);
